import { render, staticRenderFns } from "./refundorderlist.vue?vue&type=template&id=c86587a0&scoped=true"
import script from "./refundorderlist.vue?vue&type=script&lang=js"
export * from "./refundorderlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86587a0",
  null
  
)

export default component.exports